<template>
  <div class="home">
    <section class="left">
      <div class="title">研究报告</div>
      <div class="list">
        <el-tree :data="reportList" :props="defaultProps" node-key="id" :default-expanded-keys="defaultExpand">
          <span class="custom-tree-node" slot-scope="{ node }">
            <span>{{ node.label }}</span>
            <div class="box" v-if="node.level == 3" @click="goReport(node.data)">
              <div class="img">
                <img style="height:100%;width:100%;" :src="node.data.picUrl" alt />
              </div>
              <div class="detail">
                <div class="word">{{node.data.fileTitle}}</div>
                <div class="detail-down">
                  <div class="time">{{node.data.publishTime}}</div>
                </div>
              </div>
            </div>
          </span>
        </el-tree>
      </div>
    </section>
    <section class="right">
      <div class="imgs">
        <el-carousel :autoplay='false' trigger="click" @change="changeItem">
          <el-carousel-item v-for="item in titleList" :key="item.id">
            <div class='img'>
              <div class="title">{{item.indexName}}</div>
              <div class="chart">
                <three-line
                  v-if="Object.keys(lineData).length"
                  :indexId="item.indexId"
                  :lineData="lineData"
                  :ref="item.indexId + '-all'"
                ></three-line>
              </div>
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
      <div class="tabs">
        <el-tabs v-model="tabType">
          <el-tab-pane name="1">
            <span slot="label" class="label">
              <div style="text-align: center;">
                <img src="@/assets/img/home/macro_icon.png" alt />
              </div>
              <div style="text-align: center;">宏观经济</div>
            </span>
            <div class="tabcontent">
              <div class="tabtitle">日度感知+月度全口径+年度预测</div>
              <div class="cardbox">
                <el-card class="box-card" v-for="item in cardList" :key="item.id">
                  <div class="card-con" v-if="item.id !== '6'" @click="goProduct(item.title)">
                    <div class="img">
                      <img :src="item.src" alt="">
                    </div>
                    <div slot="header" class="clearfix">
                      <span class="title">{{item.title}}</span>
                    </div>
                    <div class="part">
                      <div
                        v-for="(el,k) in item.list"
                        :key="k"
                        class="text item"
                        :style="{'width': item.title == '产品概述' ? '100%' : '50%'}"
                      >· {{el}}</div>
                    </div>
                  </div>
                  <div v-else>
                    <div class="up" @click="goProduct(item.title[0])">
                      <div slot="header" class="clearfix">
                        <span class="title">
                          <img :src="item.src" alt="">
                          {{item.title[0]}}
                        </span>
                      </div>
                      <div class="part last-part">
                        <div
                          v-for="(el,k) in item.list[0]"
                          :key="k"
                          class="text item"
                          :style="{'width': '50%'}"
                        >· {{el}}
                        </div>
                      </div>
                    </div>
                    <div class="down" @click="goProduct(item.title[1])">
                      <div slot="header" class="clearfix">
                        <span class="title">
                          <img :src="item.src" alt="">
                          {{item.title[1]}}
                        </span>
                      </div>
                      <div class="part last-part">
                        <div
                          v-for="(el,k) in item.list[1]"
                          :key="k"
                          class="text item"
                          :style="{'width': '50%'}"
                        >· {{el}}
                        </div>
                      </div>
                    </div>
                  </div>
                </el-card>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane name="2">
            <span slot="label">
              <div style="text-align: center">
                <img src="@/assets/img/home/area.png" alt />
              </div>
              <div style="text-align: center;">区域数字政府</div>
            </span>
            <div class="tabcontent">
              <div>
                <div class="tabtitle">
                  <img src="@/assets/img/home/icon_11.png" alt />
                  区域经济运行感知预测预警系统
                </div>
                <div class="cardbox">
                  <el-card class="box-card area-card" v-for="item in cardList3" :key="item.id">
                    <div class="card-con" @click="goProduct(item.title)">
                      <div class="img">
                        <img :src="item.src" alt="">
                      </div>
                      <div slot="header" class="clearfix">
                        <span class="title">{{item.title}}</span>
                      </div>
                      <div class="part">
                        <div
                          v-for="(el,k) in item.list"
                          :key="k"
                          class="text item"
                          :class="[el== '立即查看>>' ? 'see' : '']"
                          :style="{'width': item.list.length>4 ? '33%' : '50%'}"
                        >· {{el}}</div>
                      </div>
                    </div>
                  </el-card>
                </div>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane name="3">
            <span slot="label">
              <div style="text-align: center">
                <img src="@/assets/img/home/company_icon.png" alt />
              </div>
              <div style="text-align: center;">产业链</div>
            </span>
            <div class="tabcontent">
              <div>
                <div class="tabtitle">
                  <img src="@/assets/img/home/icon_7.png" alt />
                  钢铁行业预测预警系统
                </div>
                <div class="cardbox">
                  <el-card class="box-card steel" v-for="item in cardList22" :key="item.id">
                    <div class="card-con" @click="goProduct(item.title)">
                      <div class="img">
                        <img :src="item.src" alt="">
                      </div>
                      <div slot="header" class="clearfix">
                        <span class="title">{{item.title}}</span>
                      </div>
                      <div class="part">
                        <div
                          v-for="(el,k) in item.list"
                          :key="k"
                          class="text item"
                          :class="[el== '立即查看>>' ? 'see' : '']"
                          :style="{'width': item.list.length>4 ? '33%' : '50%'}"
                        >· {{el}}</div>
                      </div>
                    </div>
                  </el-card>
                </div>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane name="4">
            <span slot="label">
              <div style="text-align: center">
                <img src="@/assets/img/home/company.png" alt />
              </div>
              <div style="text-align: center;">企预测</div>
            </span>
            <div class="tabcontent">
              <div>
                <div class="tabtitle">
                  <img src="@/assets/img/home/icon_10.png" alt />
                  企预测
                </div>
                <div class="cardbox">
                  <el-card class="box-card other-card" v-for="item in cardList2" :key="item.id">
                    <div class="card-con" @click="goProduct(item.title, item.id)">
                      <div class="img">
                        <img :src="item.src" alt="">
                      </div>
                      <div slot="header" class="clearfix">
                        <span class="title">{{item.title}}</span>
                      </div>
                      <div class="part">
                        <div
                          v-for="(el,k) in item.list"
                          :key="k"
                          class="text item"
                          :class="[el== '立即查看>>' ? 'see' : el== '搜索企业' ? 'item1' : '']"
                          :style="{'width': '100%'}"
                        >· {{el}}</div>
                      </div>
                    </div>
                  </el-card>
                </div>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane name="5">
            <span slot="label">
              <div style="text-align: center">
                <img src="@/assets/img/home/capital_icon.png" alt />
              </div>
              <div style="text-align: center;">资本市场</div>
            </span>
            <div class="tabcontent">
              <div class="contact">
                <p>请联系我们：</p>
                <p style="font-size: 14px;">电话:15210925572</p>
                <p style="font-size: 14px;">邮箱:TengjingAI@tjresearch.com</p>
              </div>
              <!-- <div>
                <div class="tabtitle">
                  <img src="@/assets/img/home/icon_8.png" alt />
                  申万行业高频模拟和预测系统
                </div>
                <div class="cardbox">
                  <el-card class="box-card other-card" v-for="item in cardList1" :key="item.id">
                    <div class="card-con" @click="goProduct(item.title)">
                      <div class="img">
                        <img :src="item.src" alt="">
                      </div>
                      <div slot="header" class="clearfix">
                        <span class="title">{{item.title}}</span>
                      </div>
                      <div class="part">
                        <div
                          v-for="(el,k) in item.list"
                          :key="k"
                          class="text item"
                          :class="[el== '立即查看>>' ? 'see' : '']"
                          :style="{'width': '50%'}"
                        >· {{el}}</div>
                      </div>
                    </div>
                  </el-card>
                </div>
              </div>
              <div class="line"></div>
              <div>
                <div class="tabtitle">
                  <img src="@/assets/img/home/icon_9.png" alt />
                  大宗商品预测预警系统
                </div>
                <div class="cardbox">
                  <el-card class="box-card other-card" v-for="item in cardList11" :key="item.id">
                    <div class="card-con" @click="goProduct(item.title, item.id)">
                      <div class="img">
                        <img :src="item.src" alt="">
                      </div>
                      <div slot="header" class="clearfix">
                        <span class="title">{{item.title}}</span>
                      </div>
                      <div class="part">
                        <div
                          v-for="(el,k) in item.list"
                          :key="k"
                          class="text item"
                          :class="[el== '立即查看>>' ? 'see' : '']"
                          :style="{'width': item.list.length>4 ? '33%' : '50%'}"
                        >· {{el}}</div>
                      </div>
                    </div>
                  </el-card>
                </div>
              </div> -->
            </div>
          </el-tab-pane>
          <el-tab-pane name="6">
            <span slot="label">
              <div style="text-align: center">
                <img src="@/assets/img/home/areadevelop_icon.png" alt />
              </div>
              <div style="text-align: center;">双碳&绿色核算</div>
            </span>
            <div class="tabcontent">
              <div>
                <div class="tabtitle">
                  <img src="@/assets/img/home/icon_12.png" alt />
                  绿色发展核算分析系统
                </div>
                <div class="cardbox">
                  <el-card class="box-card area-card" v-for="item in cardList33" :key="item.id">
                    <div class="card-con" @click="goProduct(item.title)">
                      <div class="img">
                        <img :src="item.src" alt="">
                      </div>
                      <div slot="header" class="clearfix">
                        <span class="title">{{item.title}}</span>
                      </div>
                      <div class="part">
                        <div
                          v-for="(el,k) in item.list"
                          :key="k"
                          class="text item"
                          :class="[el== '立即查看>>' ? 'see' : '']"
                          :style="{'width': item.list.length>4 ? '33%' : '50%'}"
                        >· {{el}}</div>
                      </div>
                    </div>
                  </el-card>
                </div>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </section>
  </div>
</template>

<script>
import { getReportList, getRotationList, getRotationData } from "@/api/home";
import { selectFileByid } from "@/api/report";
import threeLine from "./components/threeLine.vue";

export default {
  data() {
    return {
      defaultProps: {
        children: 'list',
        label: 'name'
      },
      defaultExpand: [],
      tabType: "1",
      reportList: [],
      titleList: [],
      lineData: {},
      cardList: [
        {
          id: "1",
          src: require("@/assets/img/home/gaishu.png"),
          title: "产品概述",
          list: ["宏观高频模拟和预测", "行业高频模拟和预测", "国民经济运行全口径数据库"]
        },
        {
          id: "2",
          src: require("@/assets/img/home/icon_2.png"),
          title: "宏观高频模拟和预测库",
          list: ["总量", "价格", "金融", "国际"]
        },
        {
          id: "3",
          src: require("@/assets/img/home/icon_3.png"),
          title: "行业高频模拟和预测库",
          list: ["工业", "农业", "服务业", "建筑业"]
        },
        {
          id: "4",
          src: require("@/assets/img/home/icon_4.png"),
          title: "宏观和行业全口径数据库",
          list: ["宏观", "行业", "结构", "拉动"]
        },
        {
          id: "5",
          src: require("@/assets/img/home/NSG.png"),
          title: "NSG资讯：高频模拟GDP走势",
          list: ["生产法GDP", "SHAP值", "资讯"]
        },
        {
          id: "6",
          src: require("@/assets/img/home/baogao.png"),
          title: ["腾景宏观高频研报", "腾景宏观全口径研报"],
          list: [["快报", "周报", "月报", "年报"], ["快报", "周报", "月报", "年报"]]
        }
      ],
      cardList1: [
        {
          id: "1",
          src: require("@/assets/img/home/gaishu.png"),
          title: "产品概述",
          list: ["立即查看>>"]
        },
        {
          id: "2",
          src: require("@/assets/img/home/ku.png"),
          title: "申万行业高频模拟和预测库",
          list: ["一级行业", "二级行业"]
        },
        {
          id: "3",
          src: require("@/assets/img/home/baogao.png"),
          title: "腾景申万行业研报",
          list: ["快报", "周报"]
        }
      ],
      cardList11: [
        {
          id: "1",
          src: require("@/assets/img/home/gaishu.png"),
          title: "产品概述",
          list: ["立即查看>>"]
        },
        {
          id: "2",
          src: require("@/assets/img/home/baogao.png"),
          title: "腾景大宗商品预测预警研报",
          list: ["快报", "周报"]
        }
      ],
      cardList2: [
        {
          id: "1",
          src: require("@/assets/img/home/gaishu.png"),
          title: "产品概述",
          list: ["立即查看>>"]
        },
        {
          id: "2",
          src: require("@/assets/img/home/ku.png"),
          title: "企预测",
          list: ["搜索企业"]
        },
      ],
      cardList22: [
        {
          id: "1",
          src: require("@/assets/img/home/gaishu.png"),
          title: "产品概述",
          list: ["立即查看>>"]
        },
        {
          id: "2",
          src: require("@/assets/img/home/ku.png"),
          title: "钢铁行业预测预警库",
          list: ["上游行业", "钢铁", "下游行业"]
        },
        {
          id: "3",
          src: require("@/assets/img/home/baogao.png"),
          title: "腾景钢铁行业预测预警研报",
          list: ["快报", "周报"]
        }
      ],
      cardList3: [
        {
          id: "1",
          src: require("@/assets/img/home/gaishu.png"),
          title: "产品概述",
          list: ["立即查看>>"]
        },
        {
          id: "2",
          src: require("@/assets/img/home/ku.png"),
          title: "区域经济运行感知预测预警库",
          list: ["首页", "地区宏观", "地区行业", "增长动能", "高频模拟", "腾景指数"]
        },
      ],
      cardList33: [
        {
          id: "1",
          src: require("@/assets/img/home/gaishu.png"),
          title: "产品概述",
          list: ["立即查看>>"]
        },
        {
          id: "2",
          src: require("@/assets/img/home/ku.png"),
          title: "绿色发展核算分析库",
          list: ["首页", "生态", "环境", "碳汇", "碳排放", "能源"]
        },
      ]
    };
  },
  components: {
    threeLine
  },
  created() {
    this.getReportList();
    this.getRotationList();
  },
  methods: {
    async getReportList() {
      let { data } = await getReportList();
      this.reportList = data.resultBody.reverse();
      this.defaultExpand = this.reportList.map(item => item.id)
    },
    async getRotationList() {
      let { data } = await getRotationList();
      this.titleList = data.resultBody;
      this.getRotationData(this.titleList[0].indexId)
    },
    changeItem(val) {
      this.getRotationData(this.titleList[val].indexId)
    },
    async getRotationData(curId) {
      let params = {
        id: curId
      }
      let { data } = await getRotationData(params);
      this.lineData = data.resultBody;
      // 画图
      if (this.lineData.dataList.length) {
        this.$nextTick(() => {
          this.$refs[curId + "-all"][0].drawline();
        })
      }
    },
    goReport(val) {
      this.getReportDetail(val);
    },
    async getReportDetail(val) {
      let { data } = await selectFileByid({
        id: val.id,
        sysId: val.systemName
      });
      this.goReportDetail(data.resultBody);
    },
    // 去报告详情
    goReportDetail(src) {
      // 存在浏览器缓存  解决刷新丢失
      sessionStorage.setItem("src", src);
      let routerJump = this.$router.resolve({
        name: "Detail"
      });
      window.open(routerJump.href, "_blank");
    },
    goProduct(val, flag) {
      // 企预测产品概述先不跳转
      if(this.tabType == '4' && val == '产品概述' && flag) return
      // 大宗产品概述先不跳转
      if(this.tabType == '5' && val == '产品概述' && flag) return
      // 区域库&绿色库先不跳转
      if(this.tabType == '2' && val !== '产品概述') return
      if(this.tabType == '6' && val !== '产品概述') return
      this.$router.push({
        path: val.substr(val.length-2,2) == '研报' ? "/report" : "/product",
        query: {
          system: this.tabType,
          id: val
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.home {
  display: flex;
  justify-content: space-between;
  height: 100%;
  background: #f7f7f7;
  margin-top: 20px;
  .left {
    width: 30%;
    background: #ffffff;
    margin-right: 20px;
    .title {
      padding: 20px 10px;
      font-weight: 600;
    }
    .list {
      padding: 0 20px;
      overflow-y: auto;
      max-height: 1060px;
      /deep/ .el-tree-node>.el-tree-node__children {
        border-bottom: 1px solid #f0f0f0;
      }
      /deep/ .el-tree>.el-tree-node>.el-tree-node__content{
        padding: 4px 0;
      }
      /deep/ .el-tree>.el-tree-node>.el-tree-node__children>.el-tree-node>.el-tree-node__content{
        padding: 4px 0;
      }
      /deep/ .el-tree>.el-tree-node>.el-tree-node__children>.el-tree-node>.el-tree-node__children>.el-tree-node>.el-tree-node__content{
        height: 120px;
      }
      .box {
        display: flex;
        cursor: pointer;
        .img {
          background: #f7f7f7;
          margin-right: 20px;
          width: 120px;
          height: 80px;
        }
        .detail {
          width: 200px;
          font-size: 14px;
          .word {
            height: 60px;
            white-space: normal;
            word-break: break-all;
            word-wrap: break-word;
            overflow-y: auto;
          }
          .detail-down {
            display: flex;
            justify-content: space-between;
            .time {
              color: #646464;
              margin-top: 4px;
            }
            .btn {
              .el-button {
                background: #ff8e5c;
                line-height: 0;
                color: #ffe3d7;
                border-color: #ff8e5c;
                font-size: 12px;
              }
            }
          }
        }
      }
    }
  }
  .right {
    width: 70%;
    display: flex;
    flex-direction: column;
    .imgs {
      height: 280px;
      margin-bottom: 16px;
      background: #ffffff;
      .img {
        .title {
          padding: 10px 20px;
        }
        .chart {
          height: 250px;
          padding: 0 20px;
        }
      }
      .el-carousel {
        height: 280px;
      }
      /deep/ .el-carousel__container {
        height: 280px;
      }
      /deep/ .el-carousel__button {
        background-color: #000;
      }
      .el-carousel__item h3 {
        color: #475669;
        font-size: 14px;
        opacity: 0.75;
        line-height: 150px;
        margin: 0;
      }
      .el-carousel__item:nth-child(2n) {
        background-color: #fff;
      }
      .el-carousel__item:nth-child(2n + 1) {
        background-color: #fff;
      }
    }
    .tabs {
      flex: 1;
      background: #ffffff;
      /deep/ .el-tabs__item {
        color: #a3a6b4;
        padding: 20px 52px;
        img {
          width: 50px;
          height: 50px;
        }
      }
      /deep/ .el-tabs__nav-wrap::after {
        height: 0;
      }
      /deep/ .el-tabs__item.is-active {
        color: #f6895a;
      }
      /deep/ .el-tabs__nav-scroll {
        // padding: 0 100px;
      }
      /deep/ .el-tabs__nav {
        padding-bottom: 16px;
      }
      /deep/ .el-tabs__active-bar {
        width: 57px;
        background-color: #ff8e5c;
        height: 3px;
      }
      .tabcontent {
        padding: 0 20px;
        .contact {
          margin: 30px 36%;
        }
        .line {
          height: 2px;
          width: 100%;
          background-color: #e7e7e7;
          margin: 30px 0;
        }
        .tabtitle {
          text-align: center;
          height: 50px;
          line-height: 50px;
          font-size: 18px;
          font-weight: 500;
          margin-top: 20px;
          img {
            width: 36px;
            height: 36px;
            margin-right: 10px;
            vertical-align: middle;
          }
        }
        .cardbox {
          display: flex;
          flex-wrap: wrap;
          justify-content: center;
          align-items: center;
          overflow-y: auto;
          /deep/ .el-card__header {
            border-bottom: none;
            padding-bottom: 10px;
            text-align: center;
          }
          .text {
            font-size: 14px;
          }
          .item {
            text-align: left;
            margin-bottom: 14px;
            padding-left: 40px;
            box-sizing: border-box;
          }
          .item1 {
            text-align: center;
            padding-left: 0;
          }
          .clearfix:before,
          .clearfix:after {
            display: table;
            content: "";
          }
          .clearfix:after {
            clear: both;
          }
          .box-card {
            width: 30%;
            height: 270px;
            margin: 20px 10px;
            overflow-y: auto;
            cursor: pointer;
            .card-con {
              display: flex;
              flex-direction: column;
              align-items: center;
              .img {
                width: 38px;
                height: 38px;
                margin-bottom: 20px;
                img {
                  width: 100%;
                  height: 100%;
                }
              }
            }
            .title {
              font-weight: 700;
              img {
                vertical-align: middle;
              }
            }
            .part {
              display: flex;
              flex-wrap: wrap;
              margin-top: 20px;
              // padding-left: 30px;
              width: 100%;
              .see {
                color: #3375ff;
                width: 100%!important;
                text-align: center;
                padding-left: 0;
              }
            }
            .last-part {
              margin-top: 0;
            }
          }
          .last-card {
            width: 80%;
            height: 150px;
            .card-con {
              .img {
                margin-bottom: 6px;
              }
            }
          }
          .area-card {
            width: 39%;
            height: 200px;
            .card-con {
              .img {
                margin-bottom: 6px;
              }
            }
          }
          .other-card {
            height: 160px;
            .card-con {
              .img {
                margin-bottom: 6px;
              }
            }
          }
          .steel {
            height: 200px;
            .card-con {
              .img {
                margin-bottom: 6px;
              }
            }
          }
        }
      }
    }
  }
}
</style>